<!--
	Copyright (c) 2017-present, flop! contributors
	SPDX-License-Identifier: AGPL-3.0-or-later
	https://framagit.org/flopedt/flopedt
-->

<script setup lang="ts">
import { ActionStatus, useUndoRedoStore } from '@/stores/undoredo.ts'

import SimpleButton from '@uikit/button/SimpleButton.vue'

import BackIcon from '~mingcute/arrow/back_2_line.svg'
import ForwardIcon from '~mingcute/arrow/forward_2_line.svg'

const undoredo = useUndoRedoStore()
</script>

<template>
  <!-- TODO: make pretty -->
  <div
    v-for="action in undoredo.actions"
    :key="action.$id"
    :class="{
      entry: true,
      committed: action.status === ActionStatus.COMMITTED,
      undone: action.status === ActionStatus.UNDONE,
      reverted: action.status === ActionStatus.REVERTED,
    }"
  >
    {{ action.type }}
    {{ action.source }}
    {{ action.isLocalLatest ? '(local latest)' : '' }}
    {{ action.isRemoteLatest ? '(remote latest)' : '' }}

    <SimpleButton v-if="!action.isLocalLatest" @click="undoredo.goto(action)">
      <BackIcon v-if="action.status !== ActionStatus.UNDONE" />
      <ForwardIcon v-else />
    </SimpleButton>
  </div>
</template>

<style scoped>
.entry:not(:nth-last-child) {
  /* temporary */
  border-bottom: 1px black solid;
}
</style>
